import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import SimpleRightArrowIconSvg from './SimpleRightArrowIconSvg'

const SimpleRightArrowIcon = (props: IconProps): ReactElement => (
    <Icon component={SimpleRightArrowIconSvg} {...props} />
)

export default SimpleRightArrowIcon
